module.exports = __webpack_public_path__ + "img/vendre.0e7154ff.webp";